import { useEffect, useState } from "react";

const navLinks = [
  { href: "#hot", label: "热搜榜" },
  { href: "#event", label: "事件排行" },
  { href: "#category", label: "分类热榜" },
  { href: "#topics", label: "瓜点解析" },
  { href: "#faq", label: "常见问题" },
  { href: "#about", label: "关于我们" },
];

export default function TopNav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-background-50/95 backdrop-blur border-b border-background-200/70" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-20 max-w-[1200px] items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
            <i className="ri-fire-fill text-xl"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-extrabold tracking-wide text-foreground-950">吃瓜热门</span>
            <span className="mt-1 text-[11px] text-foreground-500">CHIGUA HOT LIST</span>
          </span>
        </a>

        <div className="hidden items-center gap-1 lg:flex">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="rounded-full px-4 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-700"
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="hidden items-center gap-3 lg:flex">
          <span className="flex items-center gap-2 rounded-full border border-accent-200 bg-accent-50 px-3 py-1.5 text-xs text-accent-800">
            <span className="h-2 w-2 rounded-full bg-accent-500 animate-tickerPulse"></span>
            实时更新中
          </span>
          <a
            href="#about"
            className="whitespace-nowrap rounded-full bg-foreground-950 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            关注我们
          </a>
        </div>

        <button
          type="button"
          aria-label="切换菜单"
          className="flex h-10 w-10 items-center justify-center rounded-lg text-foreground-900 hover:bg-background-100 lg:hidden"
          onClick={() => setOpen((v) => !v)}
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-2xl`}></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200/70 bg-background-50 px-4 py-4 lg:hidden">
          <div className="flex flex-col gap-1">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-700"
              >
                {l.label}
              </a>
            ))}
            <div className="mt-2 flex items-center justify-between px-3">
              <span className="flex items-center gap-2 text-xs text-accent-800">
                <span className="h-2 w-2 rounded-full bg-accent-500 animate-tickerPulse"></span>
                实时更新中
              </span>
              <a
                href="#about"
                className="whitespace-nowrap rounded-full bg-foreground-950 px-4 py-2 text-xs font-medium text-background-50"
              >
                关注我们
              </a>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}